import React, { useState } from "react";
import { useLocation } from "react-router-dom";

import {
  Home,
  Property,
  BovPilotBlue,
  CowMenu,
  User,
  AccountLogout,
  Hamburguer,
  IconX,
  Users,
  Task,
  IconManagement,
} from "../../assets/svg";
import {
  Container,
  Header,
  MenuHamburguer,
  Logout,
  CloseHeader,
} from "./styles";
import { useAuth } from "../../hooks/useAuth";
import { useTranslate } from "../../hooks/useTranslate";
import { Button, Stack, SvgIcon } from "@mui/material";

const SideBar = () => {
  const { signOut } = useAuth();
  const { pathname } = useLocation();
  const { translate } = useTranslate();
  // const navigate = useNavigate();

  const [openHamburguer, setOpenHamburguer] = useState(false);

  const menu = [
    {
      key: 1,
      label: translate("sidebar.item_1"),
      icon: Home,
      url: "/content-center",
    },
    {
      key: 3,
      label: translate("sidebar.item_4"),
      icon: Property,
      url: "/properties",
    },
    {
      key: 5,
      label: translate("sidebar.item_5"),
      icon: Users,
      url: "/collaborators",
    },
    {
      key: 2,
      label: translate("sidebar.item_2"),
      icon: CowMenu,
      url: "/animals",
    },
    {
      key: 6,
      label: translate("sidebar.item_6"),
      icon: Task,
      url: "/tasks",
    },
    {
      key: 7,
      label: translate("sidebar.item_7"),
      icon: IconManagement,
      url: "/managements",
    },
    {
      key: 4,
      label: translate("sidebar.item_3"),
      icon: User,
      url: "/profile",
    },
  ];

  // const navigateUser = useCallback(
  //   (url: string) => {
  //     navigate(url);
  //   },
  //   [navigate]
  // );

  return (
    <>
      <MenuHamburguer>
        <button
          onClick={() => {
            setOpenHamburguer(true);
          }}
        >
          <Hamburguer />
        </button>
        <BovPilotBlue />
      </MenuHamburguer>
      <Container isActive={openHamburguer}>
        <Header>
          <CloseHeader
            onClick={() => {
              setOpenHamburguer(false);
            }}
          >
            <IconX />
          </CloseHeader>
          <BovPilotBlue />
        </Header>
        <Stack sx={{ m: 2 }} spacing={1}>
          {menu.map((item) => (
            <Button
              variant={pathname.includes(item.url) ? "contained" : "text"}
              color={"secondary"}
              component={"a"}
              href={item.url}
              // currentItemActive={pathname.includes(item.url)}
              key={item.key}
              startIcon={
                <SvgIcon
                  sx={{
                    width: 20,
                    height: 20,
                    display: "flex",
                    justifyContent: "center",
                    mx: "auto",
                  }}
                >
                  {item.icon?.()}
                </SvgIcon>
              }
              sx={{
                justifyContent: "flex-start",
                color: "white",
                fontWeight: "bold",
                textTransform: "capitalize",
              }}
            >
              {item.label}
            </Button>
          ))}
          <Logout onClick={signOut}>
            <AccountLogout />
            <span>{translate("sidebar.signout")}</span>
          </Logout>
        </Stack>
      </Container>
    </>
  );
};

export { SideBar };
